import React from 'react';
import { Modal, Form, InputNumber, DatePicker, Button } from 'antd';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../../variables/api/axiosInstance';
import ParamMotifSelect from '../../../../components/ParamMotifSelect';

export default function CreerPrefinancementModal({ open, sinistre, onClose, onSuccess }) {
    const { t } = useTranslation('dossierFinance');
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = React.useState(false);

    const submit = async (vals) => {
        setSubmitting(true);
        try {
            await axiosInstance.post('/v1/prefinancements', {
                sinistreTrackingId: sinistre?.sinistreTrackingId,
                montantPrefinance: vals.montant,
                datePrefinancement: vals.date.format('YYYY-MM-DD'),
                motifDemande: vals.motifDemande,
            });
            toast.success(t('prefinancements.creer.succes'));
            form.resetFields();
            onSuccess?.();
        } catch (e) {
            toast.error(e.response?.data?.message || t('prefinancements.creer.erreur'));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal title={t('prefinancements.creer.titre')} open={open} onCancel={onClose} footer={null} destroyOnClose>
            <Form form={form} layout="vertical" onFinish={submit}
                initialValues={{ date: dayjs() }}>
                <Form.Item name="montant" label={t('prefinancements.creer.montant')}
                    rules={[{ required: true, message: t('prefinancements.creer.montantRequis') }]}>
                    <InputNumber style={{ width: '100%' }} min={1}
                        formatter={v => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                        parser={v => (v || '').replace(/\s/g, '')} />
                </Form.Item>
                <Form.Item name="date" label={t('prefinancements.creer.date')} rules={[{ required: true }]}>
                    <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
                <Form.Item name="motifDemande" label={t('prefinancements.creer.motif')}
                    rules={[{ required: true, message: t('prefinancements.creer.motifRequis') },
                            { max: 500, message: t('prefinancements.creer.motifMax') }]}>
                    <ParamMotifSelect
                        type="PREFINANCEMENT"
                        placeholder={t('prefinancements.creer.motifPlaceholder')}
                    />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button onClick={onClose}>{t('prefinancements.creer.annuler')}</Button>
                    <Button type="primary" htmlType="submit" loading={submitting}
                        style={{ background: '#1a6b3c', borderColor: '#1a6b3c' }}>
                        {t('prefinancements.creer.enregistrer')}
                    </Button>
                </div>
            </Form>
        </Modal>
    );
}
